import { FeedType, MainPageType } from './models';
import { TFunction } from '@wix/wix-i18n-config';

type HeaderTabItem = {
  id: FeedType;
  title: string;
  isActive: boolean;
  feedType: FeedType | null;
};

type GenerateHeaderTabsDto = {
  t: TFunction;
  mainPageType: MainPageType;
  activeFeedType: string;
};

export const generateHeaderTabs = ({
  t,
  mainPageType,
  activeFeedType,
}: GenerateHeaderTabsDto): HeaderTabItem[] => {
  const isMainPageCategories = mainPageType === MainPageType.Categories;

  const categoriesItem: HeaderTabItem = {
    id: FeedType.Categories,
    title: t('tabs.categories'),
    isActive: activeFeedType === FeedType.Categories,
    feedType: isMainPageCategories ? null : FeedType.Categories,
  };

  const postsItem: HeaderTabItem = {
    id: FeedType.Posts,
    title: t('tabs.posts'),
    isActive: activeFeedType === FeedType.Posts,
    feedType: isMainPageCategories ? FeedType.Posts : null,
  };

  const myPostsItem: HeaderTabItem = {
    id: FeedType.MyPosts,
    title: t('tabs.my-posts'),
    isActive: activeFeedType === FeedType.MyPosts,
    feedType: FeedType.MyPosts,
  };

  return [
    isMainPageCategories ? categoriesItem : postsItem,
    isMainPageCategories ? postsItem : categoriesItem,
    myPostsItem,
  ];
};
